"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenExpiredError = void 0;
const common_1 = require("../common");
class AuthTokenExpiredError extends common_1.AuthError {
    constructor(tokenExpiredError) {
        super(common_1.UnauthorizedHttpError.EXPIRED_JWT_ERROR);
        this.expiredAt = tokenExpiredError.expiredAt;
    }
}
exports.AuthTokenExpiredError = AuthTokenExpiredError;
//# sourceMappingURL=AuthTokenExpiredError.js.map